/* eslint-disable max-len */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import icons from '../../../data/icons';
import { getCMSEmployee } from '../../helpers/fetchCmsContent';
import CapitalText from '../../helpers/CapitalText';
import Directus from '../../helpers/directusLink';
import blankImage from '../../../assets/images/about/blank.webp';

const getCMSlinkImage = (id, extention = '') => `${ process.env.REACT_APP_CMS }/assets/${ id }${ extention }`;

const AboutPerspectives = ({ t, language }) => {
    const [employees, setEmplyee] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getCMSEmployee();
            setEmplyee(data);
        };

        fetchData();
    }, []);

    const employeesByTranslation = useMemo(() => employees.map(({ translations, ...employee }) => {
        const translation = Directus.getTranslationByLang(translations, language, ['position']);
        return { ...employee, ...translation };
    }), [language, employees]);

    return (
        <div className="about-perspectives">
            <h1 className="about-perspectives-title">
                {t('about.perspectives.title')}
            </h1>
            <div className="about-perspectives-people">
                {employeesByTranslation.map((elem) => (
                    <div className="about-perspectives-person" key={ elem.id }>
                        <img
                          className="about-perspectives-image"
                          src={ elem.photo ? getCMSlinkImage(elem.photo) : blankImage }
                          alt=""
                        />
                        <div className="about-perspectives-content">
                            <div
                              className="about-perspectives-icon"
                            >
                                { elem.icon ? <img
                                  className="about-perspectives-image"
                                  src={ getCMSlinkImage(elem.icon) }
                                  alt=""
                                /> : <div className="about-perspectives-image"/>}
                            </div>
                            <p
                              className="about-perspectives-person-occupation"
                            >
                                <CapitalText text={ typeof elem.position === 'string' ? elem.position : '' }/>
                            </p>
                            <div className="about-perspectives-data">
                                {icons.social.linkedin ? <a
                                  className="about-perspectives-data-icon"
                                  href={ elem.linkedin }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  dangerouslySetInnerHTML={ { __html: icons.social.linkedin } }
                                /> : null}
                                <h3 className="about-perspectives-person-name">
                                    { elem.name || '' }{elem.name && elem.surname ? ' ' : '' }{elem.surname || ''}
                                </h3>
                            </div>
                        </div>
                    </div>
        ))}
            </div>
        </div>
    );
};

AboutPerspectives.propTypes = {
    t: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired
};

export default AboutPerspectives;



// WEBPACK FOOTER //
// ./src/components/content/about/AboutPerspectives.jsx